import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AddRecipientComponent } from '../add-recipient/add-recipient.component';
import { AppState } from 'src/app/core/app.state';
import { Store } from '@ngrx/store';
import { FetchUsers, getNotifications, updateNotifications } from '../../store/settings.actions';
import { INotification, INotificationType, IUser } from '../../models/settings.models';
import { Subscription } from 'rxjs';
import {
  getUserAvatarSrc,
  getUserColor,
  getUserInitials,
} from 'src/app/shared/utils/user-color.util';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit, OnDestroy {
  notifications$ = this.store.select((state) => state.settings.notifications);
  allNotifications: INotification[] = [];
  notificationsTypes: INotificationType[] = [];
  notification!: INotification;
  recipients: IUser[] = [];
  subscriptions: Subscription[] = [];
  activeTabIndex: number = 0;

  // Shared avatar helpers — same initials and stable per-user colour used by the
  // users table, the sidebar footer and Smart Inbox.
  readonly getUserInitials = getUserInitials;
  readonly getUserColor = getUserColor;
  readonly getUserAvatarSrc = getUserAvatarSrc;

  constructor(
    public dialog: MatDialog,
    private store: Store<AppState>,
  ) { }

  ngOnInit(): void {
    this.store.dispatch(FetchUsers({page: {number: 1, size: 0}}));
    this.store.dispatch(getNotifications());
    
    const sub1 = this.notifications$.subscribe((notifications) => {
      if(notifications && notifications.length > 0) {
        this.allNotifications = notifications;
        this.setActiveNotification(0);
      }
    });
    this.subscriptions.push(sub1);
  }

  addRecipient() {
    const dialogRef = this.dialog.open(AddRecipientComponent, {
      data: this.recipients
    });
    
    dialogRef.afterClosed().subscribe((result: IUser) => {
      if (result) {
        this.recipients = [...this.recipients, result];
        this.save();
      }
    });
  }

  setActiveNotification(tabIndex: number) {
    if (this.allNotifications && this.allNotifications.length > tabIndex) {
      this.activeTabIndex = tabIndex;
      this.notification = this.allNotifications[tabIndex];
      this.recipients = [...this.allNotifications[tabIndex].users];
      this.notificationsTypes = [...this.allNotifications[tabIndex].types];
    }
  }

  removeRecipient(recipient: IUser) {
    this.recipients = this.recipients.filter((r) => r.id !== recipient.id);
    this.save();
  }

  save(): boolean | void {
    if (!this.notification) {
      return;
    }
    
    const payload = {
      user_ids: this.recipients.map((r) => r.id),
      type_ids: [this.notificationsTypes[0].id]
    };
    
    this.store.dispatch(updateNotifications({
      id: this.notification.id, 
      notificationType: payload
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub => sub.unsubscribe()));
  }

  getNotificationTypeDisplayName(notification: INotification): string {
    return notification.types.map(type => type.name).join(', ');
  }
}